module.exports = __webpack_public_path__ + "img/e_3_5_r.9ce6a498.png";